import QUERYPARAMS_GET_SUCCESS from '../actionTypes/QueryParamsActionTypes';

const getQueryParams = (payload) => ({
    type: QUERYPARAMS_GET_SUCCESS,
    payload,
});

export default getQueryParams;
